module.exports = __webpack_public_path__ + "static/media/cg.07691c97.svg";